var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilWrite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232:12350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 6.66675V14.3334C13.0002 14.687 12.8597 15.0262 12.6096 15.2762C12.3596 15.5263 12.0205 15.6667 11.6668 15.6667H1.66683C1.31321 15.6667 0.974069 15.5263 0.72402 15.2762C0.473972 15.0262 0.333496 14.687 0.333496 14.3334V3.00008C0.333496 2.64646 0.473972 2.30732 0.72402 2.05727C0.974069 1.80722 1.31321 1.66675 1.66683 1.66675H10.3335",
    stroke: "#8A8886",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53849 8.87592L6.18115 9.81859L7.12382 7.46125L13.2525 1.33325L14.6665 2.74725L8.53849 8.87592Z",
    stroke: "#8A8886",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6664 2.74733L13.2524 1.33333L13.9591 0.625995C14.1467 0.438398 14.4011 0.333008 14.6664 0.333008C14.7978 0.333008 14.9279 0.358882 15.0492 0.409153C15.1706 0.459423 15.2809 0.533107 15.3738 0.625995C15.4667 0.718883 15.5403 0.829158 15.5906 0.950522C15.6409 1.07189 15.6668 1.20196 15.6668 1.33333C15.6668 1.46469 15.6409 1.59477 15.5906 1.71613C15.5403 1.8375 15.4667 1.94777 15.3738 2.04066L14.6664 2.74733Z",
    stroke: "#8A8886",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232:12350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWrite);
export default __webpack_public_path__ + "static/media/PencilWrite.f283b738.svg";
export { ForwardRef as ReactComponent };